// A video's poster is its first frame, so a post that opens with a video gets that still
// wherever a single picture of the post is shown (carousel, sidebar, OpenGraph).
const regex = /<img[^>]*src\s*=\s*["']([^"']*)["']|<video[^>]*poster\s*=\s*["']([^"']*)["']/u

export function extractFirstImageSource(htmlString: string | null) {
    if (!htmlString) {
        return
    }

    const matchList = htmlString.match(regex)
    if (!matchList) {
        return
    }

    return matchList[1] ?? matchList[2]
}
